module.exports = __webpack_public_path__ + "img/step2.a78b0b36.png";